import type { BookingSearch } from "@/lib/bookingSearch"
import { distanceOptionToKey } from "@/lib/geolocation/distance/distance"

export const buildBookingSearchCacheKeys = ({
  position,
  distance,
  service,
}: BookingSearch.Cache.KeyData): BookingSearch.Cache.Keys => {
  return [`bookingSearch`, position, distanceOptionToKey(distance), service]
}
